import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'


class Arrow extends Component {
  render(){


    const color = this.props.color || "secondary"
    const position = this.props.position || "absolute"

    const style = {
      container: {
        bottom: (position === "absolute" ? 0 : ''),
        left: (position === "absolute" ? '50%' : ''),
        transform: (position === "absolute" ? 'translateX(-50%)' : ''),
        position: position,
        zIndex: 10000
      },
      arrow: {
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: '100%',
        fontSize: '1.6rem',
      }
    }

    return (
      <div className={"mb-3 mb-sm-5 " + (this.props.className || "")} style={style.container}>
        <AnchorLink href={"#"+this.props.href} className={ "text-white bg-" + color + " shadow-sm d-flex align-items-center justify-content-center"} style={style.arrow}>
          <i className="fas fa-angle-down"></i>
        </AnchorLink>
      </div>
    )
  }
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/ui-elements/Arrow.js